import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { TelaDeConteudos } from '@/components/gestor/conteudos/TelaDeConteudos'

/*
 * `/gestor/conteudos`: a lista dos tooltips e a fila dos que esperam revisão.
 * A guarda e a recusa por cargo moram na casca (`/gestor`), então esta tela só
 * monta para quem tem a área Conteúdos.
 */
function Tela() {
  const { novo } = Route.useSearch()
  const navigate = useNavigate({ from: '/gestor/conteudos' })
  return (
    <TelaDeConteudos
      abrirQuadro={novo === true}
      aoFecharQuadro={() => {
        // Sem isto, recarregar a página depois de fechar o quadro o reabriria.
        if (novo !== undefined) void navigate({ search: {}, replace: true })
      }}
    />
  )
}

/*
 * `?novo=true` abre o quadro do tooltip novo já na carga: é o endereço a que o
 * observatório devolve a pessoa depois de posicionar, e serve a link e a
 * captura de tela sem clique.
 */
export const Route = createFileRoute('/gestor/conteudos')({
  validateSearch: (busca: Record<string, unknown>): { novo?: true } =>
    busca.novo === true || busca.novo === 'true' ? { novo: true as const } : {},
  component: Tela,
})
